import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SortingService {
	sortAlphabetically(property: string) {
		return function (a: any, b: any) {
			if (a[property] < b[property]) {
				return -1;
			} else if (a[property] > b[property]) {
				return 1;
			} else {
				return 0;
			}
		};
	}
}
